export const role_hierarchy: { [key: string]: string | string[] } = {
  // changes here need to be reflected in backend: security.yaml
  ROLE_ADMIN: ['ROLE_STAFF'],
};
